var $c709bb06dc2a8e23$exports = {};
$c709bb06dc2a8e23$exports = {
    "decrease": (args)=>`Sc\u{103}dere ${args.fieldLabel}`,
    "increase": (args)=>`Cre\u{219}tere ${args.fieldLabel}`,
    "numberField": `C\xe2mp numeric`
};


export {$c709bb06dc2a8e23$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
